// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__IkY2K","button":"Counter_button__3vmvi","disabled":"Counter_disabled__2DLBK","number":"Counter_number__2VlZP"};